import {
  Home,
  Image,
  History,
  Wallet,
  CreditCard,
  Settings,
  CircleHelp,
  Sparkles,
} from "lucide-react";

import { NavLink, useNavigate } from "react-router-dom";

const menus = [
  {
    name: "Dashboard",
    icon: Home,
    path: "/",
  },
  {
    name: "Optimize Image",
    icon: Image,
    path: "/optimize",
  },
  {
    name: "History",
    icon: History,
    path: "/history",
  },
  // {
  //   name: "Wallet",
  //   icon: Wallet,
  //   path: "/wallet",
  // },
  
  
  {
    name: "Buy Credits",
    icon: CreditCard,
    path: "/buy",
  },
   {
    name: "Transactions",
    icon: Wallet,
    path: "/transactions",
  },
  {
    name: "Settings",
    icon: Settings,
    path: "/settings",
  },
  {
    name: "Support",
    icon: CircleHelp,
    path: "/support",
  },
];

export default function Sidebar() {

  const navigate = useNavigate()
  return (
    <div className="w-[280px] overflow-scroll  bg-white h-screen border-r flex flex-col">

      {/* Logo */}
      <div className="h-24 flex items-center px-6 border-b">

        {/* <div className="w-10 h-10 rounded-xl bg-violet-100 flex items-center justify-center">
          <Sparkles
            size={22}
            className="text-violet-600"
          />
        </div> */}

        <h2 className="">
          <img  src="https://i.ibb.co/HTJMwrc0/crop-logo-shipless.png"/>
          {/* ShipLess */}
          {/* <span className="text-violet-600">
            {" "}AI
          </span> */}
        </h2>

      </div>

      {/* Menu */}
      <div className="flex-1 px-4 py-6">

        <div className="space-y-2">

          {menus.map((item) => {
            const Icon = item.icon;

            return (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-4 px-4 py-4 rounded-2xl transition-all
                  ${
                    isActive
                      ? "bg-violet-50 text-violet-600 font-semibold"
                      : "text-gray-700 hover:bg-gray-50"
                  }`
                }
              >
                <Icon size={20} />

                <span>{item.name}</span>
              </NavLink>
            );
          })}

        </div>

      </div>

      {/* Upgrade Card */}
      <div className="p-4">

        <div className="bg-violet-50 rounded-3xl p-5 text-center">

          <div className="w-14 h-14 mx-auto rounded-2xl bg-white flex items-center justify-center">

            <Sparkles
              className="text-violet-600"
              size={24}
            />

          </div>

          <h3 className="mt-4 font-bold text-lg">
            Upgrade your plan
          </h3>

          <p className="text-gray-500 text-sm mt-2">
            Get more credits and exclusive benefits
          </p>

          <button
          onClick={()=>navigate('/buy')}
            className="
            mt-5
            w-full
            bg-violet-600
            hover:bg-violet-700
            text-white
            py-3
            rounded-xl
            font-medium
            "
          >
            Buy Credits
          </button>

        </div>

      </div>

    </div>
  );
}